module.exports = __webpack_public_path__ + "img/data-table-dark-01.a572b7cd.jpg";